import {
  ConsultaSeguimentoPergunta10ExemplosEnum,
  ConsultaSeguimentoPergunta10Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-10/model-consultaSeguimentoPergunta10'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { convertToPassouFalhou, HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta10Model {
  header: MchatRfAplicacaoQueryModel
  exemplosPassou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  exemplosFalhou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  perguntaMaiorFrequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta10Model
}

export const convertAplicacaoPergunta10 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta10Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_10_01)
  const perguntaMaiorFrequencia = aplicacoes.find(
    (aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_10_09
  )
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_10_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_10_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))
  if (header == undefined) return null

  return {
    header,
    exemplosPassou,
    exemplosFalhou,
    perguntaMaiorFrequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_10_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_10_EXEMPLOS: {
        PASSOU: convertAplicacoesToExemplos(exemplosPassou),
        FALHOU: convertAplicacoesToExemplos(exemplosFalhou),
      },
      PERGUNTA_10_FREQUENCIA: convertToPassouFalhou(perguntaMaiorFrequencia?.stPassou),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta10ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta10ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const PERGUNTA_10_EXEMPLOS_PASSOU = [
  MChatPerguntaEnum.PERGUNTA_10_02,
  MChatPerguntaEnum.PERGUNTA_10_03,
  MChatPerguntaEnum.PERGUNTA_10_04,
]

const PERGUNTA_10_EXEMPLOS_FALHOU = [
  MChatPerguntaEnum.PERGUNTA_10_05,
  MChatPerguntaEnum.PERGUNTA_10_06,
  MChatPerguntaEnum.PERGUNTA_10_07,
  MChatPerguntaEnum.PERGUNTA_10_08,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta10ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta10ExemplosEnum.PROCURA]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.FALA_OU_EMITE_SOM]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.PARA_O_QUE_ESTA_FAZENDO]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.NAO_DA_RESPOSTA]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.PARECE_OUVIR_IGNORA]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_NA_FRENTE]: undefined,
  [ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_SE_TOCADO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta10ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_10_02]: ConsultaSeguimentoPergunta10ExemplosEnum.PROCURA,
  [MChatPerguntaEnum.PERGUNTA_10_03]: ConsultaSeguimentoPergunta10ExemplosEnum.FALA_OU_EMITE_SOM,
  [MChatPerguntaEnum.PERGUNTA_10_04]: ConsultaSeguimentoPergunta10ExemplosEnum.PARA_O_QUE_ESTA_FAZENDO,
  [MChatPerguntaEnum.PERGUNTA_10_05]: ConsultaSeguimentoPergunta10ExemplosEnum.NAO_DA_RESPOSTA,
  [MChatPerguntaEnum.PERGUNTA_10_06]: ConsultaSeguimentoPergunta10ExemplosEnum.PARECE_OUVIR_IGNORA,
  [MChatPerguntaEnum.PERGUNTA_10_07]: ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_NA_FRENTE,
  [MChatPerguntaEnum.PERGUNTA_10_08]: ConsultaSeguimentoPergunta10ExemplosEnum.SO_RESPONDE_SE_TOCADO,
}
